import React, {Component} from "react";

import Ventanilla from "./VentanillaView";
import {VentanillaService} from "../../service/ventanilla/VentanillaService";
import {Button} from "primereact/button";
import {Growl} from "primereact/growl";
import {textWithAccent} from "../../utils/formatters/Accent";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";

export default class VentanillaContainer extends Component {
    constructor(props) {
        super(props);

        this.ventanillaService = new VentanillaService();

        this.getBestOrders = this.getBestOrders.bind(this);

        this.state = {
            bestOrders: [this.getBestOrders()],
            lenderOrders: [],
            borrowerOrders: [],
            loans: [],
            tabValue: 'Prestamista',
            selectedBestOrder: [],
            isLoading: true,
            tabIndex: -1,
            items: [
                {
                    label: 'Postura Prestamista',
                },
                {
                    label: 'Postura Prestataria',
                },
                {
                    label: 'Hechos',
                },
            ],
        };

        this.handlerLenderOrder = this.handlerLenderOrder.bind(this);
        this.handlerBorrowerOrder = this.handlerBorrowerOrder.bind(this);
        this.lenderOrderActionTemplate = this.lenderOrderActionTemplate.bind(this);
        this.borrowerOrderActionTemplate = this.borrowerOrderActionTemplate.bind(this);
        this.todayTrade = this.todayTrade.bind(this);
        this.changeTab = this.changeTab.bind(this);

        this.intervalID = setInterval(this.getBestOrders, 10000);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }

    changeTab(event) {
        this.setState({
            tabIndex: event.index,
        });
    }


    handlerBorrowerOrder(folio) {
        this.ventanillaService.getOrderPtt(folio).then(response => {
            if (response.message !== "") {
                this.growl.show({severity: 'error', summary: 'Error.', detail: textWithAccent(response.message)});
            } else {
                this.props.history.push({
                    pathname: '/app/ventanillaOrderPtt/',
                    state: {
                        returnPath: '/app/ventanilla/',
                        folio: folio
                    },
                });
            }
        });
    }

    handlerLenderOrder(rowData) {
        this.ventanillaService.getOrderPtm(rowData['folio']).then(response => {
            if (response.message !== "") {
                this.growl.show({severity: 'error', summary: 'Error.', detail: textWithAccent(response.message)});
            } else {
                this.props.history.push({
                    pathname: '/app/ventanillaOrderPtm/',
                    state: {
                        returnPath: '/app/ventanilla/',
                        folio: rowData['folio'],
                        amount: rowData['cantidad'],
                        rate: rowData['tasa'],
                        maturity: rowData['plazo'],
                        minReward: response.payload[0].premioMin,
                    },
                });
            }
        });
    }

    handleSelectBestOrder = (event) => {
        this.setState(
            {
                selectedBestOrder: event.value,
                lenderOrders: this.getLenderOrders(event.value.emisora),
                borrowerOrders: this.getBorrowerOrders(event.value.emisora),
                loans: this.getLoans(event.value.emisora)
            }
        )
    };

    handleChangeTabIndex = (event) => {
        this.setState({tabValue: event.index})
    };

    lenderOrderActionTemplate(rowData, column) {
        return <Button type="button"
                       iconPos="left"
                       label="Tomar Postura"
                       style={{marginRight: '.5em'}}
                       onClick={() => this.handlerLenderOrder(rowData)}
        />;
    }


    borrowerOrderActionTemplate(rowData, column) {
        return <Button type="button"
                       iconPos="left"
                       label="Tomar Postura"
                       style={{marginRight: '.5em'}}
                       onClick={() => this.handlerBorrowerOrder(rowData['folio'])}
        />;
    }

    getBestOrders() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
        return this.ventanillaService.getBestOrders().then(
            mejoresPosturas => {
                let bestOrders = [];

                mejoresPosturas.map(best => {
                    bestOrders.push({
                        emisora: best.emisora,
                        cantidadPtm: best.posturaPrestamista.cantidad,
                        plazoPtm: best.posturaPrestamista.plazo,
                        tasaPtm: best.posturaPrestamista.tasa * 100,
                        sobreTasaPtm: best.posturaPrestamista.sobreTasa * 100,
                        cantidadPtt: best.posturaPrestatario.cantidad,
                        plazoPtt: best.posturaPrestatario.plazo,
                        tasaPtt: best.posturaPrestatario.tasa * 100,
                        sobreTasaPtt: best.posturaPrestatario.sobreTasa * 100,
                    });
                    return '';
                });


                this.setState({
                    bestOrders: bestOrders,
                    isLoading: false
                });
            }
        )
    }

    getLenderOrders(emisora) {
        this.setState({
            isLoading: true
        });
        return this.ventanillaService.getLenderOrders(emisora).then(
            posturasPrestamista => {
                let fixOrder = [];

                posturasPrestamista.map(order => {
                    order.tasa = order.tasa * 100;
                    order.sobreTasa = order.sobreTasa * 100;
                    order.banOTC = order.banOTC === 'OTC' ? 'Si' : '';
                    fixOrder.push(order);
                    return '';
                });


                this.setState({
                    lenderOrders: fixOrder,
                    isLoading: false
                });
            })
    }

    getBorrowerOrders(emisora) {
        this.setState({
            isLoading: true
        });
        return this.ventanillaService.getBorrowerOrders(emisora).then(
            posturasPrestatario => {
                let fixOrder = [];

                posturasPrestatario.map(order => {
                    order.tasa = order.tasa * 100;
                    order.sobreTasa = order.sobreTasa * 100;
                    fixOrder.push(order);
                    return '';
                });

                this.setState({
                    borrowerOrders: fixOrder,
                    isLoading: false
                })
            })
    }

    getLoans(emisora) {
        this.setState({
            isLoading: true
        });
        return this.ventanillaService.getLoans(emisora).then(
            hechos =>
                this.setState({
                    loans: hechos,
                    isLoading: false
                }))
    }

    todayTrade() {
        this.props.history.push({
            pathname: '/app/todayTradeVentanilla/',
            state: {
                returnPath: '/app/ventanilla/'
            },
        });
    }

    getColumnGroupBestOrders() {
        return (
            <ColumnGroup>
                <Row>
                    <Column header="Instrumento" rowSpan={3}/>
                    <Column header="Mejor Orden" colSpan={8}/>
                </Row>
                <Row>
                    <Column header="Prestamista" colSpan={4}/>
                    <Column header="Prestatario" colSpan={4}/>
                </Row>
                <Row>
                    <Column header="Cantidad" style={{textAlign: 'right'}}/>
                    <Column header="Plazo" style={{textAlign: 'right'}}/>
                    <Column header="Tasa" style={{textAlign: 'right'}}/>
                    <Column header="Sobretasa" style={{textAlign: 'right'}}/>
                    <Column header="Cantidad" style={{textAlign: 'right'}}/>
                    <Column header="Plazo" style={{textAlign: 'right'}}/>
                    <Column header="Tasa" style={{textAlign: 'right'}}/>
                    <Column header="Sobretasa" style={{textAlign: 'right'}}/>
                </Row>
            </ColumnGroup>
        );
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        let headerGroupBestOrders = this.getColumnGroupBestOrders();

        let headerLoans =
            <div style={{textAlign: 'right'}}>
                <Button type="button" icon="pi pi-external-link" iconPos="left" label="XLS"
                        style={{marginRight: '.5em'}}/>
                <Button type="button" icon="pi pi-external-link" iconPos="left" label="PDF"
                        style={{marginRight: '.5em'}}/>
            </div>;

        let headerTrades =
            <div style={{textAlign: 'right'}}>
                <Button type="button"
                        iconPos="left"
                        label="Hechos del Día"
                        style={{marginRight: '.5em'}}
                        onClick={this.todayTrade}
                />
            </div>;

        const {bestOrders} = this.state;
        const {lenderOrders} = this.state;
        const {borrowerOrders} = this.state;
        const {loans} = this.state;
        const {tabValue, selectedBestOrder} = this.state;


        return <Ventanilla
            messagesGrowl={messagesGrowl}
            headerGroupBestOrders={headerGroupBestOrders}
            headerLoans={headerLoans}
            bestOrders={bestOrders}
            lenderOrders={lenderOrders}
            lenderOrderActionTemplate={this.lenderOrderActionTemplate}
            borrowerOrderActionTemplate={this.borrowerOrderActionTemplate}
            borrowerOrders={borrowerOrders}
            loans={loans}
            tabValue={tabValue}
            handleChangeTabIndex={this.handleChangeTabIndex}
            handleSelectBestOrder={this.handleSelectBestOrder}
            isLoading={this.state.isLoading}
            selectedBestOrder={selectedBestOrder}
            headerTrades={headerTrades}
            changeTab={this.changeTab}
            tabIndex={this.state.tabIndex}
            items={this.state.items}
        />
    }
};
